import { useTranslation } from 'react-i18next';
import React from 'react';
import { MARKETING_LINKS } from '../../constant';

export const QuickLinks = ({ view = 'desktop' }) => {
  const { t } = useTranslation();

  return (
    <>
      <span className="text-pddarkblue lg:text-white text-4xl font-black">Quick Links</span>
      <ul data-testid={`${view === 'mobile' ? 'mobile' : 'desktop'}-quick-links`} role="list" className={`mt-3 flex flex-1 flex-col shadow-none ${view === 'mobile' ? 'gap-y-3' : 'gap-y-1'}`}>
        {MARKETING_LINKS.map((item, i) => (
          <li key={`quick-link-${i}`}>
            <a
              href={`${process.env.REACT_APP_MARKETING_URL}${item.path}`}
              target="_blank"
              className={`p-0 font-semibold no-underline ${view === 'mobile' ? 'text-pddarkblue' : 'text-white hover:text-white/60'} focus:underline`}
            >
              {t(item.label)}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
};
